import React from "react";

function Button({
  label,
  type = "submit",
  status = "",
  disabled = false,
  onClick,
  icon = null,
  className,
  name,
  imgsrc = null,
}) {
  return (
    <button
      type={type}
      className={`p-0 btn button-${status} btn-lg w-inherit cursor-pointer ${className} button-style`}
      disabled={disabled}
      onClick={onClick}
      name={name}
    >
      {imgsrc && <img src={imgsrc} alt="" aria-hidden="true" className="btn-imgsrc pl-2-" />}
      {icon != null && (
        <span className="me-2 font-size-16">
          <i className={"fa fa-" + icon}></i>
        </span>
      )}
      {label}

      {type === "submit" && disabled && (
        <div
          className="spinner-border spinner-border-sm ms-1"
          role="status"
        ></div>
      )}
    </button>
  );
}

export default Button;
